import { createSlice } from "@reduxjs/toolkit";

export const emptyWorkforceFilters = {
    name: '',
    email: '',
    phone: '',
    designation_id: '',
    RoleID: '',
    optima_number: '',
    official_number: '',
    passport_number: '',
    nationality: '',
    status: '',
}

const initialState = {
    workforceFilters: emptyWorkforceFilters
}

const workforceFilterSlice = createSlice({
    name: `workforceFilter`,
    initialState,
    reducers: {
        setWorkforceFilter: (state, action) => {
            state.workforceFilters = action.payload;
        },
        resetWorkforceFilters: (state) => {
            state.workforceFilters = emptyWorkforceFilters;
        }
    }
})

export const { setWorkforceFilter, resetWorkforceFilters } = workforceFilterSlice.actions
export default workforceFilterSlice.reducer;